module.exports = __webpack_public_path__ + "img/sk-partners-novy-cas.1e4c397e.png";